/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate} from "react-router-dom";
import { GAMELEAVE_URL} from "../services/apiUrl";
import { useRest, CALL_TYPES } from "../services/rest/api";
import Utility from "../utility/utility";
import { exitGame } from "../redux/actions/joinAction";
import { actionOpenSituationArray, actionOpenSituationId, actionOverlayId } from "../redux/actions/game_dashboard_card_create_action";
import {
  mask,
  masks,
  mask4,
  cardiver,
  mask2,
  mask1,
  mask6,
  gameboardlogo,
  blurpen2,
  cardlogo,
  countdownandbuzzer, idle_timer
} from "../assets";
import { default as CardoverlayCommon } from "./CardoverlayCommon";
import { default as ChanceCardCommon } from "./ChanceCardCommon";

import questionJSON from '../assets/questionfile/QuestionFileNew1.json';
var backgroundTimer, idleTimer;

var isFirstQuestion = true
var activeOutId = -1
var openId = -1
var openSituationArrayvar = []
var nextMemberId = 0

var isActiveVar = false
var showRealQuestionvar = false
var showOpenQuestionVar = false
var assetsObject = {}
var firstSelectionVisibility = true
var secondSelectionVisibility = true
var thirdSelectionVisibility = true
var isChanceCard = false
var usedNos = []
let roomId = 0
let memberId = 0
let is_facilitator = false

var is_everyone_card = 0
var gameOver = false

var backLogTurn = false
const Gameboard = (props, { navigation }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const gameData = useSelector((state) => state?.joinReducer || null);
  const [scoreboard, setScoreboard] = useState({ gamedata: [], open_situation: [] });
  const [turnMemberId, setTurnMemberId] = useState(0);
  const [countCardType1, setCountCardType1] = useState(3);
  const [countCardType2, setCountCardType2] = useState(3);
  const [countCardType3, setCountCardType3] = useState(3);
  const [countCardType4, setCountCardType4] = useState(3);
  const [showBlurImg, setShowBlurImg] = useState(false);
  const [isStarted, setIsStarted] = useState(false);

  const [showTimer, setShowTimer] = useState(false);
  const [showQuestionPopup, setShowQuestionPopup] = useState(false);
  const [showOpenQuestionPopup, setOpenShowQuestionPopup] = useState(false);

  const [seconds, setSeconds] = useState(40);
  const [isActive, setIsActive] = useState(false);
  const [trackSeconds, setTrackSeconds] = useState(10);
  const [isIdleActive, setIsIdleActive] = useState(false);
  const [showTimeoutPopup, setShowTimeoutPopup] = useState(false);
  const [hasDrawnFirstCard, setHasDrawnFirstCard] = useState(false);
  const [hasSeenScenarioCard, setHasSeenScenarioCard] = useState(false);
  const [hasSeenChanceCard, setHasSeenChanceCard] = useState(false);
  const [hasSeenEveryoneCard, setHasSeenEveryoneCard] = useState(false);
  const [showScenarioHint, setShowScenarioHint] = useState(false);
  const [showChanceHint, setShowChanceHint] = useState(false);
  const [showEveryoneHint, setShowEveryoneHint] = useState(false);
  roomId = gameData?.data?.room_id;
  memberId = gameData?.data?.id;
  is_facilitator = gameData?.data?.is_facilitator;

  // The first user to start the game is the player with the smallest member_id
  // (turns rotate in ascending member_id order — see sortAndSetNextUser).
  // The "Please make sure everyone is in the Breakout Room…" reminder should
  // appear only for this player, on their first turn, until they click Draw Card.
  const firstPlayerMemberId =
    scoreboard?.data && scoreboard.data.length > 0
      ? scoreboard.data.reduce(
          (minId, p) => (p.member_id < minId ? p.member_id : minId),
          scoreboard.data[0].member_id
        )
      : null;
  const isFirstPlayer = firstPlayerMemberId === memberId;
  const setCardTypeState = (obj) => {
    setCountCardType1(obj["Time/Energy"]);
    setCountCardType2(obj["Home/Family"]);
    setCountCardType3(obj["Money/Debt"]);
    setCountCardType4(obj["Work/Job"]);
  }

  useEffect(() => {
    Utility.isSignedIn(gameData?.data).then((value) => {
      if (!value) {
        navigate("/home");
      }
    });
  }, [gameData?.data]);


  const sortAndSetNextUser = async (items) => {
    const itemArray = await items.sort(function (a, b) {
      return a.member_id - b.member_id;
    });
    const position = itemArray.findIndex(x => x.member_id == memberId);
    if (position === -1) {
      return
    }
    if (itemArray.length === (position + 1)) {
      nextMemberId = itemArray[0].member_id
    } else {
      nextMemberId = itemArray[(position + 1)].member_id
    }
  }

  useEffect(() => {
    async function handleCardEffect() {
    if (gameData?.activeCardoverlayId >= 0 && activeOutId >= 0 && isStarted) {

      if (questionJSON[(activeOutId)]?.Decision === 4) {
        isChanceCard = true
      } else {
        isChanceCard = false
      }

      if (questionJSON[(activeOutId)]?.Decision === 2) {
        const socket = await Utility.getConnectedSocket()
        is_everyone_card = memberId === turnMemberId ? 1 : 2;

        if (turnMemberId === memberId) {
          socket.emit("client_everyone", JSON.stringify({ game_id: 1, room_id: roomId, member_id: memberId, question_id: activeOutId }));
        }
      }
      firstSelectionVisibility = await Utility.checkAssetEligibility(questionJSON[(activeOutId)]?.Column7, assetsObject)
      secondSelectionVisibility = await Utility.checkAssetEligibility(questionJSON[(activeOutId)]?.Column8, assetsObject)
      thirdSelectionVisibility = await Utility.checkAssetEligibility(questionJSON[(activeOutId)]?.Column9, assetsObject)
      showCardPopup()
    }
  }
  handleCardEffect();

  }, [gameData?.activeCardoverlayId]);


  useEffect(() => {
    if(turnMemberId === 0){
      return
    }
    if (turnMemberId === memberId && !isFirstQuestion && !showOpenQuestionPopup && !showQuestionPopup) {
      backLogTurn = false
      startIdleTracker()
    } else if (turnMemberId === memberId && !isFirstQuestion) {
      backLogTurn = true
    }

  }, [turnMemberId])


  useEffect(() => {
    async function handleOpenSituation() {
    if (gameData?.openSituationId >= 0 && isStarted) {

      if (questionJSON[(openId)]?.Decision === 4) {
        isChanceCard = true
      } else {
        isChanceCard = false
      }
      is_everyone_card = 0
      firstSelectionVisibility = await Utility.checkAssetEligibility(questionJSON[(openId)]?.Column7, assetsObject)
      secondSelectionVisibility = await Utility.checkAssetEligibility(questionJSON[(openId)]?.Column8, assetsObject)
      thirdSelectionVisibility = await Utility.checkAssetEligibility(questionJSON[(openId)]?.Column9, assetsObject)
      await setOpenShowQuestionPopup(true)
      await openCardModal(true)
    }
  }
  handleOpenSituation();

  }, [gameData?.openSituationId]);



  useEffect(() => {
    async function initializeGame() {
    Utility.setRandomiserArray()
    const socket = await Utility.getConnectedSocket()
    activeOutId = 0
    openId = 0
    openSituationArrayvar = []
    isFirstQuestion = true
    nextMemberId = 0
    isActiveVar = false
    showRealQuestionvar = false
    showOpenQuestionVar = false
    assetsObject = {}
    firstSelectionVisibility = true
    secondSelectionVisibility = true
    thirdSelectionVisibility = true
    isChanceCard = false
    usedNos = []

    gameOver = false

    if (roomId !== "" && roomId !== undefined) {
      socket.emit("room", roomId);

      socket.emit(
        "client",
        JSON.stringify({ room_id: roomId, member_id: memberId, last_question_is_opensituation: 0 })
      );
    }
    socket.on(
      "serverkeepopen", (data) => {
        const parsed_data = JSON.parse(data)
        usedNos = parsed_data.message.used_questions
        if (usedNos.length === questionJSON.length) {
          gameOver = true
        }
        if (!showOpenQuestionPopup && !showQuestionPopup && gameOver) {
          closeMusicAndTimer()
        }
        if (parsed_data.message.member_id === memberId) {
          socket.emit(
            "client",
            JSON.stringify({
              room_id: roomId, member_id: parsed_data.message.member_id,
              last_question_is_opensituation: parsed_data.message.open_situation, is_everyone_card: parsed_data.message.is_everyone_card
            })
          );
        }

      }
    );
    socket.on("server", (data) => {
      const result = JSON.parse(data);
      console.log("server", result);
      setScoreboard(result.gamedata);
      updateAssetListing(result.gamedata);

      setTurnMemberId(result.gamedata.turn_member_id)
      sortAndSetNextUser(result.gamedata.data)

      if (result.gamedata.data.length > 1){
        setIsStarted(true);
      }else{
        setIsStarted(false);
      }
    });
    socket.on("server_game_end", (data) => {
      const result = JSON.parse(data);
      closeMusicAndTimer()
      navigate("/endgame", {
        state: {
          data: result.scoreboard
        }
      });

    });
    socket.on("server_everyone", (data) => {
      const result = JSON.parse(data);
      if (result.message.member_id !== memberId && !is_facilitator) {
        is_everyone_card = 2
        dispatch(
          actionOverlayId(
            result.message.question_id
          )
        );
        activeOutId = result.message.question_id
        showCardPopup();
      }


    });
    socket.on("connectToRoom", (data) => {
      console.log("connectToRoom", data);
    });
    socket.on("adminRemoveMember", (data) => {
      const parsed_data = JSON.parse(data)
      if (parsed_data.member_id !== memberId) {
        Utility.showToast("info", "You have been removed from the game by the facilitator.");
        Leave_game();
      }
    })

    return () => {
      Utility.disconnectSocket()

      activeOutId = 0
      openId = 0
      openSituationArrayvar = []
      isFirstQuestion = true
      nextMemberId = 0
      isActiveVar = false
      showRealQuestionvar = false
      showOpenQuestionVar = false
      assetsObject = {}
      firstSelectionVisibility = true
      secondSelectionVisibility = true
      thirdSelectionVisibility = true
      isChanceCard = false
      usedNos = []
      memberId = 0
      roomId = 0
      gameOver = false
      setHasDrawnFirstCard(false)
      setHasSeenScenarioCard(false)
      setHasSeenChanceCard(false)
      setHasSeenEveryoneCard(false)

    }
  }
  initializeGame();
  }, [props]);

  const { data, fetchData: LeaveGame } = useRest({
    URL: GAMELEAVE_URL,
    CALL_TYPE: CALL_TYPES.POST,
    PAYLOAD: {
      room_id: JSON.stringify(gameData?.data?.room_id),
      id: JSON.stringify(gameData?.data?.id),
    },
    lazy: true,
  });

  const Leave_game = async () => {
    try {
      const socket = await Utility.getConnectedSocket();
      socket.emit("room_leave", JSON.stringify({ room_id: roomId, next_user_turn: nextMemberId }));

      Utility.disconnectSocket();

      await LeaveGame();
      await clearGameStorage();
    } catch (error) {
      console.error("An error occurred while leaving the game:", error);
    }
  };

  useEffect(() => {
    window.addEventListener('beforeunload', alertUser)
    window.addEventListener('unload', handleTabClosing)
    return () => {
      window.removeEventListener('beforeunload', alertUser)
      window.removeEventListener('unload', handleTabClosing)
    }
  }, [])

  const handleTabClosing = async () => {
    await Leave_game()
  }

  const alertUser = async (event) => {
    event.preventDefault()
    event.returnValue = ''
    await Leave_game()
  }

  function clearGameStorage() {
    localStorage.removeItem('roomId');
    localStorage.removeItem('memberId');
    localStorage.clear();
    
    sessionStorage.removeItem('roomId');
    sessionStorage.removeItem('memberId');
    sessionStorage.clear();

    document.cookie.split(";").forEach((cookie) => {
      document.cookie = cookie
        .replace(/^ +/, "")
        .replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`);
    });

    if ("caches" in window) {
      caches.keys().then((names) => {
        names.forEach((name) => caches.delete(name));
      });
    }
  }

  useEffect(() => {
    if (data?.status_code === 200) {
      dispatch(exitGame());
    }
  }, [data]);

  useEffect(() => {
    backgroundTimer = document.getElementById("countdownandbuzzer");
    idleTimer = document.getElementById("idle_timer");
  }, []);


  // Mark first-time-seen for each card type the moment that card type is displayed,
  // so the first-turn popup dismisses after the player has seen it once.
  // We mark it on the *next* render after the card opens, so the popup is visible
  // for the first encounter and disappears on the second.
  useEffect(() => {
    const cardOpen = showQuestionPopup || showOpenQuestionPopup;
    if (!cardOpen) {
      setShowScenarioHint(false);
      setShowChanceHint(false);
      setShowEveryoneHint(false);
      return;
    }
    if (is_everyone_card === 1 || is_everyone_card === 2) {
      if (!hasSeenEveryoneCard) {
        setShowEveryoneHint(true);
        setHasSeenEveryoneCard(true);
      }
      return;
    }
    if (isChanceCard) {
      if (!hasSeenChanceCard) {
        setShowChanceHint(true);
        setHasSeenChanceCard(true);
      }
      return;
    }
    if (!hasSeenScenarioCard) {
      setShowScenarioHint(true);
      setHasSeenScenarioCard(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showQuestionPopup, showOpenQuestionPopup]);

  useEffect(() => {
    showOpenQuestionVar = showOpenQuestionPopup
    showRealQuestionvar = showQuestionPopup
  }, [showOpenQuestionPopup, showQuestionPopup]);


  const updateAssetListing = async (game_statistics) => {
    const gameStats = game_statistics.data.filter((item, idx) => {
      return item.member_id === memberId;
    });

    if (game_statistics.data.length > 0 && game_statistics.data[0].operational_uid !== memberId) {
      return
    }
    if (gameStats[0]?.open_situation.length > 0) {
      setShowBlurImg(true);
    } else {
      setShowBlurImg(false);
    }

    assetsObject = gameStats[0]?.assets ? JSON.parse(gameStats[0]?.assets) : Leave_game();
    setCardTypeState(assetsObject);
    if (gameStats[0]?.is_everyone_card > 0) {
      is_everyone_card = 0
      closeMusicAndTimer()
      if (game_statistics.turn_member_id === memberId) {
        await setTurnMemberId(memberId)
      }
      if (gameStats[0]?.last_question_is_opensituation !== 1 && gameStats[0]?.open_situation.length > 0) {
        openSituationArrayvar = [...gameStats[0]?.open_situation]
        dispatch(
          actionOpenSituationArray(
            gameStats[0]?.open_situation
          ))
      }
      return
    }
    if (gameOver) {
      const socket = await Utility.getConnectedSocket()
      closeMusicAndTimer()
      let data = JSON.stringify({ room_id: roomId, scoreboard: game_statistics })
      socket.emit(
        "client_game_end", data

      );
      console.log("End_game_data1", data)


    }
    if (gameStats[0]?.last_question_is_opensituation !== 1 && gameStats[0]?.open_situation.length > 0) {
      openSituationArrayvar = [...gameStats[0]?.open_situation]
      dispatch(
        actionOpenSituationArray(
          gameStats[0]?.open_situation
        ))
      closeMusicAndTimer()
    }
    else if (openSituationArrayvar?.length > 0) {
      const pending_open_situation = [...openSituationArrayvar];
      var pos_id = pending_open_situation[0].question_id;

      if (pos_id === gameData?.openSituationId) {
        await dispatch(
          actionOpenSituationId(
            0
          ))
      }
      openId = pos_id
      dispatch(
        actionOpenSituationId(
          pos_id
        ))
      pending_open_situation.shift()

      openSituationArrayvar = [...pending_open_situation]
      dispatch(
        actionOpenSituationArray(
          ...[pending_open_situation]
        ))
    }
    else if (gameStats[0]?.last_question_is_opensituation === 1 && openSituationArrayvar?.length === 0 && isActiveVar) {
      var id = await (parseInt(await generateUniqueRandom(usedNos)))
      activeOutId = id
      dispatch(
        actionOverlayId(
          id
        ))
    }
    else if (gameStats[0]?.last_question_is_opensituation === 0 && gameStats[0]?.open_situation.length === 0) {
      closeMusicAndTimer()
    } else {
      console.log("Track-Result-12", JSON.stringify(gameStats[0]?.open_situation))
    }

  }
  const checkWhichQuestionToRender = async () => {
    resetIdleTracker()
    if (openSituationArrayvar?.length > 0) {
      var pending_open_situation = [...openSituationArrayvar];
      var pos_id = pending_open_situation[0].question_id;
      if (pos_id === openId) {
        await dispatch(
          actionOpenSituationId(
            0
          ))
      }
      openId = pos_id
      dispatch(
        actionOpenSituationId(
          pos_id
        ))
      pending_open_situation.shift()
      openSituationArrayvar = [...pending_open_situation]
      await dispatch(
        actionOpenSituationArray(
          pending_open_situation
        ))
      return;
    }

    var id = await (parseInt(await generateUniqueRandom(usedNos)))
    activeOutId = id
    await dispatch(
      actionOverlayId(
        id
      )
    );
    return;
  }

  const RenderOpenSituation = ({ scoreboard_stats }) => {
    return (
      <div className="flex items-center">
        {scoreboard_stats.length > 0 && (
          <b className="ml-2 align-middle">{scoreboard_stats.length}</b>
        )}
      </div>
    );
  };
  
  const scoreboardData = scoreboard?.data?.map((item, index) => (

    <tr
      key={index}
      className={item.member_id === turnMemberId ? "scoreboard-row-active" : ""}
    >
      {<th scope="row" className="border-right-color  font-table-head" style={item.member_id === turnMemberId ? { color: "green", padding: "4px" } : { color: "black" }}>
        {item.member_name}
      </th>}
      <td>{<RenderOpenSituation scoreboard_stats={item.open_situation} />}</td>
    </tr>
  ));

  const checkCardOverlay = async (target, question_id, card_type) => {
    const socket = await Utility.getConnectedSocket()
    var payLoad = {
      game_id: 1,
      room_id: roomId,
      member_id: memberId,
      question_id: showQuestionPopup ? parseInt(activeOutId) : parseInt(openId),
      card_type: 1,
      open_situation: 0,
      actual_question: showQuestionPopup ? 1 : 0,
      assets: JSON.stringify(card_type),
      next_user_turn: is_everyone_card === 2 ? 0 : showQuestionPopup ? nextMemberId : memberId,
      is_everyone_card: is_everyone_card,
      used_questions: usedNos
    };

    closeCardModal();
    socket.emit(
      "keepOpen",
      JSON.stringify(payLoad)
    );
  };

  const chanceCardCallback = async (card_type) => {
    const socket = await Utility.getConnectedSocket()
    var payLoad = {
      game_id: 1,
      room_id: roomId,
      member_id: memberId,
      question_id: showQuestionPopup ? parseInt(activeOutId) : parseInt(openId),
      card_type: 1,
      open_situation: 0,
      actual_question: showQuestionPopup ? 1 : 0,
      assets: JSON.stringify(card_type),
      next_user_turn: showQuestionPopup ? nextMemberId : memberId,
      is_everyone_card: is_everyone_card,
      used_questions: usedNos
    };
    closeCardModal();
    socket.emit(
      "keepOpen",
      JSON.stringify(payLoad)
    );

  };

  const generateUniqueRandom = async() => {
    if (usedNos.length < 87) {
      const array =await Utility.getRandomiserArray(usedNos)
      if (array.length >= 0){
        usedNos.push(array[0])
        return array[0]
      }
      else {
        return -1
      }
    } else {
      return -1
    }

  }
  const RenderCardType1 = () => {
    return (
      <>
        {
          <>
            <div className="back-box-game mr-2" key="card1asset1">{
              countCardType1 >= 1 && <img src={masks} className="width-gane-image" />
            }</div>
            <div className="back-box-game mr-2" key="card1asset2">{
              countCardType1 >= 2 && <img src={mask2} className="width-gane-image" />
            }</div>
            <div className="back-box-game mr-2" key="card1asset3">{
              countCardType1 === 3 && <img src={mask1} className="width-gane-image" />
            }</div>
          </>
        }
      </>
    );
  };

  const RenderCardType2 = () => {
    return (
      <>
        {
          <>
            <div className="back-box-game mr-2" key="card2asset1">
              {
                countCardType2 >= 1 && <img src={mask6} className="width-gane-image" />
              }
            </div>
            <div className="back-box-game mr-2" key="card2asset2">
              {
                countCardType2 >= 2 && <img src={mask} className="width-gane-image" />
              }
            </div>
            <div className="back-box-game mr-2" key="card2asset3">
              {
                countCardType2 === 3 && <img src={mask4} className="width-gane-image" />
              }
            </div>
          </>
        }
      </>
    );
  };

  const RenderCardType3 = () => {
    return (
      <>
        {
          <>
            <div className="back-box-game mr-2" key="card3asset1">{
              countCardType3 >= 1 && <img src={cardiver} className="width-gane-image" />
            }</div>
            <div className="back-box-game mr-2" key="card3asset2">{
              countCardType3 >= 2 && <img src={mask2} className="width-gane-image" />
            }</div>
            <div className="back-box-game mr-2" key="card3asset3">{
              countCardType3 === 3 && <img src={cardiver} className="width-gane-image" />
            }</div>
          </>
        }
      </>
    );
  };

  const RenderCardType4 = () => {
    return (
      <>
        {
          <>
            <div className="back-box-game mr-2" key="card4asset1">{
              countCardType4 >= 1 && <img src={mask6} className="width-gane-image" />
            }</div>
            <div className="back-box-game mr-2" key="card4asset2">{
              countCardType4 >= 2 && <img src={mask} className="width-gane-image" />
            }</div>
              <div className="back-box-game mr-2">{
              countCardType4 === 3 && <img src={cardiver} className="width-gane-image" />
            }</div>
          </>
        }
      </>
    );
  };

  const keepOpen = async (card_type) => {
    const socket = await Utility.getConnectedSocket()
    var payLoad = {
      game_id: 1,
      room_id: roomId,
      member_id: memberId,
      question_id: showQuestionPopup ? parseInt(activeOutId) : parseInt(openId),
      card_type: 0,
      open_situation: 1,
      actual_question: showQuestionPopup ? 1 : 0,
      assets: JSON.stringify(card_type),
      next_user_turn: is_everyone_card === 2 ? 0 : showQuestionPopup ? nextMemberId : memberId,
      is_everyone_card: is_everyone_card,
      used_questions: usedNos
    };


    closeCardModal();
    socket.emit(
      "keepOpen",
      JSON.stringify(payLoad)
    );

  };

  const autokeepOpen = async () => {
    const socket = await Utility.getConnectedSocket()
    if (showOpenQuestionPopup) {
      var id = await (parseInt(await generateUniqueRandom(usedNos)))
      activeOutId = id
    }

    var payLoad = {
      game_id: 1,
      room_id: roomId,
      member_id: memberId,
      question_id: activeOutId,
      card_type: 0,
      open_situation: 1,
      actual_question: 1,
      next_user_turn: is_everyone_card === 2 ? 0 : nextMemberId,
      is_everyone_card: is_everyone_card,
      used_questions: usedNos
    };

    closeCardModal();
    socket.emit(
      "keepOpen",
      JSON.stringify(payLoad)
    );
  };



  const toggle = () => {
    isActiveVar = true
    setIsActive(true);
  }

  const reset = () => {
    setSeconds(40);
    isActiveVar = false
    setIsActive(false);
  }

  const startIdleTracker = () => {
    if (!isFirstQuestion) {
      setTrackSeconds(10)
      setIsIdleActive(true)
    }
  }

  const resetIdleTracker = async () => {

    setIsIdleActive(false)
    setTrackSeconds(10)
    idleTimer != null && idleTimer.pause();
    idleTimer.currentTime = 0;
  }

  const createAutomaticOpenSItuation = () => {
    openSituationArrayvar = []
    dispatch(
      actionOpenSituationArray(
        []
      ))
    autokeepOpen()
  }

  let interval = null;
  let trackIdealActivtyInterval = null;
  useEffect(() => {
    interval = null;
    if (isActive) {
      backgroundTimer.play();
      interval = setInterval(() => {
         setSeconds(seconds => seconds - 1);
        if (seconds === 0 && isActive) {
          setShowTimeoutPopup(true);
          reset()
          createAutomaticOpenSItuation()
        }

      }, 1000);
    } else if (!isActive && seconds === 0) {
      clearInterval(interval);
      backgroundTimer.pause();
      backgroundTimer.currentTime = 0;

    }
    return () => clearInterval(interval);
  }, [isActive, seconds]);


  useEffect(() => {
    trackIdealActivtyInterval = null;
    if (isIdleActive) {
      var timerSec = 10
      idleTimer.play();
      trackIdealActivtyInterval = setInterval(() => {
        if (showOpenQuestionVar || showRealQuestionvar) {
          clearInterval(trackIdealActivtyInterval);
          return
        }
         timerSec = (timerSec - 1)
        setTrackSeconds(timerSec);
        if (timerSec === 0) {
          clearInterval(trackIdealActivtyInterval);
          if (!showOpenQuestionVar && !showRealQuestionvar && isIdleActive) {
            checkWhichQuestionToRender()
          }else{
            resetIdleTracker()
          }
        }

      }, 1000);
    } else if (!isIdleActive || trackSeconds === 0) {
      clearInterval(trackIdealActivtyInterval);
    }

    return () => clearInterval(trackIdealActivtyInterval);
  }, [isIdleActive]);

  const openCardModal = async (needToOpen) => {
    if (!isFirstQuestion || needToOpen) {

      toggle()
      await setShowTimer(true);
    }
  };

  const closeCardModal = async () => {
    await setShowQuestionPopup(false);
    await setOpenShowQuestionPopup(false);
    if(backLogTurn){
      backLogTurn = false
     await setTurnMemberId(0)
     await setTurnMemberId(memberId)
    }

  };
  const showCardPopup = async () => {
    await setShowQuestionPopup(true);
    openCardModal(false)
    isFirstQuestion = false
  };

  const closeMusicAndTimer = () => {
    clearInterval(interval);
    isActiveVar = false
    setIsActive(false);
    setSeconds(40);
    setTrackSeconds(10);
    setIsIdleActive(false)
    backgroundTimer != null && backgroundTimer.pause();
    backgroundTimer.currentTime = 0;

  }

  return (
    <>
      <div className="background">
        <div className="gameboard container">
          <div className={"row" + (isActive ? "" : " hide")}>
            <div className="col-md-12">
              <div className="text-center mobile-center">
                {!isChanceCard && <span className="timer">:{seconds > 0 ? seconds : 0}</span>}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 col-12">
              <div className="mt-3">
                <img src={gameboardlogo} className="gameboard-logos" />
              </div>
            </div>
            <div className="col-md-4 col-12">
              <table className="table mt-5 game-table-width">
                <tbody>
                  <tr>
                    <th
                      scope="row"
                      className="border-right-color  font-table-head"
                    >
                      PLAYERS
                    </th>
                    <th colSpan="2" className="font-table-head">
                      OPEN SITUATIONS
                    </th>
                  </tr>
                  {scoreboardData && scoreboardData.length > 0 ? (
                    <>{scoreboardData}</>
                  ) : (
                    <tr></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="row margin-percentage">
            <div className="col-md-5 col-12">
              <div className="card-yellow">
                <div className="row">
                  <div className="col-md-4 col-5 mobile-top-game">
                    <h3 className="Pacifico-Regulars mobile-font-game font-game-card font-family-size">
                      time/energy
                    </h3>
                  </div>
                  <div className="col-md-8 col-7">
                    <div className="float-right">
                      <div className="row">{<RenderCardType1 />}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-green mt-2">
                <div className="row">
                  <div className="col-md-4 col-5 mobile-top-game">
                    <h3 className="Pacifico-Regulars mobile-font-game font-family-size font-game-card">
                      home/family
                    </h3>
                  </div>
                  <div className="col-md-8 col-7">
                    <div className="float-right">
                      <div className="row">{<RenderCardType2 />}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-red mt-2">
                <div className="row">
                  <div className="col-md-4 col-5 mobile-top-game">
                    <h3 className="Pacifico-Regulars mobile-font-game font-game-card font-family-size">
                      money/debt
                    </h3>
                  </div>
                  <div className="col-md-8 col-7">
                    <div className="float-right">
                      <div className="row">{<RenderCardType3 />}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-brown mt-2">
                <div className="row">
                  <div className="col-md-4  col-5 mobile-top-game">
                    <h3 className="Pacifico-Regulars mobile-font-game font-game-card font-family-size">
                      work/job
                    </h3>
                  </div>
                  <div className="col-md-8 col-7">
                    <div className="float-right">
                      <div className="row">{<RenderCardType4 />}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {(turnMemberId === memberId && !isActive && isStarted) ? <div className="col-md-3 col-12">
              <div className="draw-card-row">
                <div className="card-blank">
                  <img src={cardlogo} className="gameboard-logo" />
                  <div className="text-center gameboard-top-card game-top-button-card">
                    <img src={mask4} className="width-set-games" />
                    <img src={masks} className="width-set-games ml-1" />
                    <img src={mask} className="width-set-games ml-1" />
                    <img src={cardiver} className="width-set-games ml-1" />
                  </div>
                  <div className="text-center">
                    <button
                      onClick={async (e) => {
                        setHasDrawnFirstCard(true)
                        checkWhichQuestionToRender()
                      }}
                      type="text"
                      className="draw-card-button"
                    >
                      DRAW CARD
                    </button>
                  </div>
                </div>
                {isFirstPlayer && !hasDrawnFirstCard && (
                  <div className="first-turn-reminder text-center encode-sans">
                    Please make sure everyone is in the Breakout Room before you click Draw Card
                  </div>
                )}
              </div>
            </div> : <></>}
            <div className="col-md-3">
              {showBlurImg ? (
                <img className="blur-image" src={blurpen2} />
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="text-right mobile-center">
                <button
                  type="text"
                  className="exit-game"
                  onClick={(e) => {
                    Leave_game()
                  }}>
                  EXIT GAME
                </button>
              </div>
            </div>
          </div>
        </div>
        {showQuestionPopup && !isChanceCard && <CardoverlayCommon checkCardOverlayCallback={checkCardOverlay} keepOpenCallback={keepOpen} questionObject={questionJSON[(activeOutId)]} assets={assetsObject} v1={firstSelectionVisibility} v2={secondSelectionVisibility} v3={thirdSelectionVisibility} />}
        {showQuestionPopup && isChanceCard && <ChanceCardCommon checkCardOverlayCallback={chanceCardCallback} keepOpenCallback={keepOpen} questionObject={questionJSON[(activeOutId)]} assets={assetsObject}  v1={firstSelectionVisibility} />}

        {showOpenQuestionPopup && !isChanceCard && <CardoverlayCommon checkCardOverlayCallback={checkCardOverlay} keepOpenCallback={keepOpen} questionObject={questionJSON[(openId)]} assets={assetsObject} v1={firstSelectionVisibility} v2={secondSelectionVisibility} v3={thirdSelectionVisibility} tag= "Open Situation"/>}
        {showOpenQuestionPopup && isChanceCard && <ChanceCardCommon checkCardOverlayCallback={chanceCardCallback} keepOpenCallback={keepOpen} questionObject={questionJSON[(openId)]} assets={assetsObject} v1={firstSelectionVisibility} tag= "Open Situation"/>}

        {/* First-turn card-type hint popups */}
        {(showQuestionPopup || showOpenQuestionPopup) && (is_everyone_card === 1 || is_everyone_card === 2) && showEveryoneHint && (
          <div className="first-card-hint first-card-hint-top encode-sans">
            This situation affects everyone. You need to make a decision; you do not have to make the same decision as everyone else.
          </div>
        )}
        {(showQuestionPopup || showOpenQuestionPopup) && !isChanceCard && (is_everyone_card !== 1 && is_everyone_card !== 2) && showScenarioHint && (
          <div className="first-card-hint first-card-hint-left encode-sans">
            Click the box for the choice you want. Your assets will adjust automatically.
          </div>
        )}
        {(showQuestionPopup || showOpenQuestionPopup) && isChanceCard && showChanceHint && (
          <div className="first-card-hint first-card-hint-right encode-sans">
            This is a Chance card. You have no decision to make.
          </div>
        )}

      </div>

      <audio id="countdownandbuzzer">
        <source src={countdownandbuzzer} type="audio/mp3" />
      </audio>
      <audio id="idle_timer">
        <source src={idle_timer} type="audio/mp3" />
      </audio>
      {showTimeoutPopup && (
        <div className="timeout-popup-overlay">
          <div className="timeout-popup-card encode-sans">
            <h3 className="timeout-popup-title">Time&apos;s Up!</h3>
            <p className="timeout-popup-text">
              You ran out of time. You will deal with your open situations at your next turn.
            </p>
            <button
              type="button"
              className="btn timeout-popup-button"
              onClick={() => setShowTimeoutPopup(false)}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export const socketEmitLeaveGame = async () => {
  const socket = await Utility.getConnectedSocket();
  socket.emit("room_leave", JSON.stringify({ room_id: roomId, next_user_turn: nextMemberId }));
}

export default Gameboard;